// extracted by mini-css-extract-plugin
export default {"main":"ExerciseDetail_main__vkfTG","left":"ExerciseDetail_left__rhmSn"};